module.exports = __webpack_public_path__ + "static/fcra-2019-20-q1-152e04873bc62b2e8f5c7ac5b5e315f9.pdf";